import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "meta-item"
}
const _hoisted_2 = { class: "value" }
const _hoisted_3 = {
  key: 1,
  class: "meta-item"
}
const _hoisted_4 = { class: "value" }
const _hoisted_5 = {
  key: 2,
  class: "meta-item"
}
const _hoisted_6 = { class: "value" }
const _hoisted_7 = {
  key: 3,
  class: "meta-item"
}
const _hoisted_8 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ps-recipe-metadata", { compact: _ctx.compact }])
  }, [
    (_ctx.prepTime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label" }, "Prep:", -1)),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.formatTime(_ctx.prepTime)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.cookTime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "label" }, "Cook:", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formatTime(_ctx.cookTime)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.totalTime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "label" }, "Total:", -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formatTime(_ctx.totalTime)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.servings)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "label" }, "Servings:", -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.servings), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}